import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import { Box, Button, SimpleGrid, Text } from "@chakra-ui/react";
import React from "react";

export default function Pagination({ page, handlePage, totalPage }) {
  let elements = [];
  for (let i = 1; i <= totalPage; i++) {
    elements.push(i);
  }
  console.log(page);

  if (totalPage === 0 || totalPage === undefined) {
    return;
  }

  return (
    <Box display="flex" justifyContent="center">
      <Button
        variant="ghost"
        disabled={page <= 1}
        onClick={() => handlePage(page - 1)}
      >
        <ChevronLeftIcon />
      </Button>
      {elements
        .slice(
          page < 3 ? 0 : page - 3,
          page < 3 ? totalPage < 5 && totalPage : page + 3
        )
        .map((item) => (
          <Button
            variant="ghost"
            borderRadius=""
            fontWeight
            color={page === item && "#2563EB"}
            onClick={() => handlePage(item)}
            borderBlockEnd={page === item && "1px solid #2563EB"}
          >
            {item}
          </Button>
        ))}
      <Button
        variant="ghost"
        disabled={page === totalPage}
        onClick={() => handlePage(page + 1)}
      >
        <ChevronRightIcon />
      </Button>
    </Box>
  );
}
